import { RootState } from 'store/rootTypes';

export const AccountSelector = (state: RootState) => state.Account;
